import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=5c30dd26&scoped=true&"
import script from "./billDetails.vue?vue&type=script&lang=js&"
export * from "./billDetails.vue?vue&type=script&lang=js&"
import style0 from "./billDetails.vue?vue&type=style&index=0&id=5c30dd26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30dd26",
  null
  
)

export default component.exports